import React from 'react';
import HelixCard from '../HelixCard';
import HelixSpinner from '../HelixSpinner';

const LoadingComponent = ({isLoading, error}) => {
  // Handle the loading state
  if (isLoading) {
    return (
      <HelixCard>
        <div style={{margin: '20px 0 40px'}}><HelixSpinner /></div>
      </HelixCard>
    );
  }
  // Handle the error state
  else if (error) {
    return <div style={{margin: '20px 0 40px', textAlign: 'center', color: '#FFF'}}>Sorry, there was a problem loading the page.</div>;
  }
  else {
    return null;
  }
};

export default LoadingComponent;
